import { render, staticRenderFns } from "./Sucursal.vue?vue&type=template&id=b1b282f0&scoped=true"
import script from "./Sucursal.vue?vue&type=script&lang=js"
export * from "./Sucursal.vue?vue&type=script&lang=js"
import style0 from "./Sucursal.vue?vue&type=style&index=0&id=b1b282f0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b282f0",
  null
  
)

export default component.exports